export const DELIVERY_PROJECT_UPDATE_TEAM = 'DELIVERY_PROJECT_UPDATE_TEAM';

export const CRITICAL_PERIOD_TYPE = {
  SYSTEM_CREATED: 'SYSTEM_CREATED',
  USER_CREATED: 'USER_CREATED',
};

export const PROJECT_TEAM_LOCATION = {
  BELARUS: 'BELARUS',
  EU: 'EU',
};

export const PROJECT_TEAM_LOCATION_LABELS = {
  BELARUS: 'Belarus',
  EU: 'European Union',
};

export const PROJECT_TEAM_TYPE = {
  SCOPE_BASED: 'SCOPE_BASED',
  TEAM_BASED: 'TEAM_BASED',
};

export const PROJECT_TEAM_TYPE_LABELS = {
  SCOPE_BASED: 'Scope based',
  TEAM_BASED: 'Team based',
};
